import api from '@cannect/services/api'

export interface SavedCard {
  id: number
  type?: string
  brand?: string
  holder?: string
  holder_name?: string
  first_digits?: string
  last4?: string
  last_digits?: string
  external_id?: string
  selected_default_card?: boolean
}

export async function listSavedCards(): Promise<SavedCard[]> {
  const { data } = await api.get('/payments/customers/cards')
  return data?.cards || []
}

export interface CreateCardPayload {
  number: string
  holder_name: string
  holder_document: string
  exp_month: number
  exp_year: number
  cvv: string
  brand?: string
  label?: string
  billing_address?: any
  selected_default_card?: boolean
}

export async function createCard(payload: CreateCardPayload) {
  const { data } = await api.post('/payments/customers/cards', { card_data: payload })
  // A API responde 201 mesmo quando não recebeu card_data (só cria/atualiza o cliente)
  if (!data?.card) throw new Error('Cartão não foi criado')
  return data
}

/**
 * external_id do cartão recém-criado. Quando o cartão já existia a API devolve
 * o resultado do update ([1]) em vez do registro, então cai no match por dígitos.
 */
export function findCreatedCardExternalId(created: any, cards: SavedCard[], number: string): string {
  const fromResponse = created?.card?.external_id
  if (fromResponse) return fromResponse

  const digits = number.replace(/\D/g, '')
  const match = cards.find(
    (c) => (c.last_digits || c.last4) === digits.slice(-4) && (!c.first_digits || c.first_digits === digits.slice(0, 6))
  )
  return match?.external_id || ''
}

export async function deleteCard(cardId: number) {
  const { data } = await api.delete(`/payments/customers/cards/${cardId}`)
  return data
}

export async function updateCard(cardId: number, payload: Partial<{ label: string; selected_default_card: boolean }>) {
  const { data } = await api.put(`/payments/customers/cards/${cardId}`, payload)
  return data
}
